var React = require('react');

function CoffeePotBgInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M385.792 416.8H1V3.79999C335.602 3.79999 396.946 288.435 385.792 416.8Z","fill":"#F0AD3C"}));
}

CoffeePotBgInline.defaultProps = {"width":"390","height":"421","viewBox":"0 0 390 421","fill":"none"};

module.exports = CoffeePotBgInline;

CoffeePotBgInline.default = CoffeePotBgInline;
